<div
  *ngIf="isLoading$ | async"
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'wcag.loading' | translate }}"
></div>

<table class="table d-flex flex-column d-md-table">
  <thead>
    <tr class="d-flex d-md-table-row">
      <th scope="col" class="col-8 col-md-6">
        {{ 'general.items' | translate }}
      </th>
      <th scope="col" class="col d-none d-md-table-cell"
        ><span *ngIf="shouldShowCategories">{{
          'general.category' | translate
        }}</span>
      </th>
      <th scope="col" class="col d-none d-md-table-cell">
        <!-- {{ 'shopModule.price' | translate }} / -->
        {{ 'shopModule.quantity' | translate }}
      </th>

      <th scope="col" class="text-end col col-md-auto">{{
        'shopModule.total' | translate
      }}</th>
      <th scope="col" class="col-1 col-md-auto"
        ><span class="visually-hidden">{{
          'wcag.qrCode' | translate
        }}</span></th
      >
    </tr>
  </thead>
  <tbody>
    <ng-container
      *ngFor="
        let saleItem of saleItems$
          | async
          | richedSaleItems: (productEntities$ | async)
      "
    >
      <tr
        data-test-id="sale-items-sale-block"
        [attr.data-test-id-sale-items-id]="saleItem.id"
        class="d-flex flex-wrap d-md-table-row justify-content-between p-sm-small"
      >
        <td
          class="saleitem-description col-12 border-0-md-down col-md-auto pb-0 pb-md-0"
        >
          <div class="product-description">
            <div class="mb-1 fw-bold">
              <span data-test-id="sale-item-description">{{
                !saleItem?.productId &&
                !saleItem?.courseId &&
                !saleItem?.subscriptionId &&
                !saleItem?.bookingId
                  ? ('saleModule.accountTransfer' | translate)
                  : saleItem.courseId
                    ? (saleItem.productId
                      | getTranslation: 'product' : 'description'
                      | async)
                    : saleItem.productId
                      ? (saleItem.productId
                        | getTranslation: 'product' : 'description'
                        | async)
                      : (saleItem.subscriptionId
                        | getTranslation: 'subscription' : 'description'
                        | async)
              }}</span>
            </div>

            <ng-container *ngIf="saleItem?.rentalId">
              <div data-test-id="sale-item-rental-period">
                {{ 'rentalModule.rentalPeriod' | translate }}:
                {{
                  (rentalEntities$ | async)[saleItem.rentalId]?.rentStartDate
                    | formatDate: 'd MMM y HH:mm'
                    | async
                }}
                -
                {{
                  (rentalEntities$ | async)[saleItem.rentalId]?.rentEndDate
                    | formatDate: 'd MMM y'
                    | async
                }}
                {{
                  (rentalEntities$ | async)[saleItem.rentalId]?.rentEndDate
                    | date: 'HH:mm'
                    | roundMinutes
                }}
              </div>
            </ng-container>
          </div>
          <div
            class="description mb-1"
            [innerHTML]="saleItemService.getSaleItemDetail(saleItem) | async"
            *ngIf="saleItemService.getSaleItemDetail(saleItem) | async"
          ></div>
        </td>
        <td
          *ngIf="shouldShowCategories"
          class="d-block col-3 col-md-auto d-md-table-cell"
        >
          <ng-container
            *ngIf="
              saleItem.subscriptionId
                ? (saleItem | getSaleItemSubscriptionPrice | async)
                : saleItem.courseId
                  ? (saleItem | getSaleItemCoursePrice | async)
                  : saleItem.rentalId
                    ? (saleItem | getSaleItemRentalProductPrice | async)
                    : (saleItem
                      | getSaleItemProductPrice
                      | async) as saleItemPriceDetails
            "
          >
            <p class="m-0" *ngIf="shouldShowBookerCategory(saleItem)">
              {{
                saleItem.customerCategory
                  | customerCategoryName
                    : (saleItem?.siteId == paymentDefaultSiteId &&
                      paymentDefaultSiteId != 0
                        ? (productEntities$ | async)[saleItem.productId]?.siteId
                        : saleItem.siteId)
                  | async
              }}
            </p>
            <p
              class="m-0"
              *ngFor="
                let familyPriceDetail of saleItemPriceDetails.familyPriceDetails
              "
            >
              {{
                familyPriceDetail.categoryId
                  | customerCategoryName
                    : (saleItem?.siteId == paymentDefaultSiteId &&
                      paymentDefaultSiteId != 0
                        ? (productEntities$ | async)[saleItem.productId]?.siteId
                        : saleItem.siteId)
                  | async
              }}
            </p>
          </ng-container>
        </td>
        <td class="col-5">
          <ng-container>
            <div
              data-test-id="sale-member-invites-quantity-and-participants"
              *ngIf="saleItem?.params?.invitedMemberEmails?.length > 0"
            >
              {{
                (productEntities$ | async)[saleItem.productId]
                  ?.linkedSubsPrice !== undefined && 0 | currency
              }}
              × {{ saleItem?.params?.invitedMemberEmails?.length }} ({{
                'memberModule.members' | translate
              }})
            </div>
          </ng-container>
          <sale-item-price-details
            *ngIf="!saleItem?.giftCardUseId"
            [saleItem]="saleItem"
          ></sale-item-price-details>
          <div class="mb-2" *ngIf="getSaleItemBasePrice(saleItem) as basePrice">
            {{ 'productModule.basePrice' | translate }}:
            {{ basePrice | currency }}
          </div>
        </td>

        <td
          data-test-id="sale-item-total-amount"
          class="col text-end text-nowrap"
          >{{ saleItem.totalPrice | currency }}
        </td>
        <td class="col-auto">
          <button
            type="button"
            class="btn btn-primary"
            *ngIf="
              showQrCodeButtonGenerate &&
                saleItem.claimCode &&
                saleItem.claimCode !== 'none' &&
                sale?.statusCode == 0 &&
                participationsFetched(saleItem) | async
            "
            (click)="showQrModal(saleItem)"
            [attr.data-test-id]="'booking-generate-qr-button'"
          >
            <i
              class="fas fa-qrcode"
              role="img"
              attr.aria-label="{{ sale?.description }} {{
                'wcag.qrCode' | translate
              }}"
            ></i>
          </button>
        </td>
      </tr>
    </ng-container>
  </tbody>
  <tfoot class="bg-light">
    <tr class="d-flex d-md-table-row">
      <td colspan="3" class="col-6 fw-bold text-body">{{
        'general.total' | translate
      }}</td>
      <td colspan="2" class="text-end col fw-bold text-body">
        <span class="text-nowrap" data-test-id="sale-total-amount">{{
          saleItemsTotal$ | async | currency
        }}</span>
      </td>
    </tr>
  </tfoot>
</table>
